@if (formGroup && inputFieldConfig?.name) {
<div [formGroup]="formGroup" class="form-group">
  <ng-template #option let-item>
    <div class="d-contents item" [innerHTML]="dropdownOptionItemTemplateFunction(item) | safeHtml"></div>
  </ng-template>

  <ng-template #selected>
    <div
      *ngIf="renderSelected() as rendered"
      class="d-contents option-selected"
      [innerHTML]="rendered | safeHtml"
    ></div>
  </ng-template>

  <finxone-select-dropdown
    [options]="options"
    [formControlName]="inputFieldConfig.name"
    [id]="inputFieldConfig.name"
    [optionValueKey]="'value'"
    [optionLabelKey]="'label'"
    [appendToBody]="true"
    [searchEnabled]="inputFieldConfig?.searchEnabled ?? false"
    [isScrollable]="inputFieldConfig?.isScrollable ?? true"
    [isScrollPeekEnabled]="inputFieldConfig?.isScrollPeekEnabled ?? false"
    [visibleItemsCount]="inputFieldConfig?.visibleItemsCount ?? defaultVisibleItemsCount"
    [menuDirection]="inputFieldConfig?.menuDirection ?? defaultMenuDirection"
    [validationConfig]="validationConfig"
    [formControlInvalid]="formControlInvalid"
    [selectedOption]="selectedItem?.['label'] ?? ''"
    [label]="inputFieldConfig?.label ?? ''"
    [placeholder]="inputFieldConfig?.inputPlaceholder ?? ''"
    [infoText]="renderedHelperTextContent ?? ''"
    [customOptionTemplate]="isLibraryConfig ? option : null"
    [customSelectedOptionTemplate]="isLibraryConfig ? selected : null"
    [inputLabelTooltipText]="inputLabelTooltipText"
  >
  </finxone-select-dropdown>
</div>

}
